import { Controller } from "@hotwired/stimulus"
import { debug } from "../debug"

export default class extends Controller {
  connect() {
    debug("Chat button controller connected");
    // Store the bound function so we can remove it later
    this.boundHandleClick = this.handleClick.bind(this);
    this.element.addEventListener('click', this.boundHandleClick);
  }

  disconnect() {
    // Use the stored bound function to properly remove the listener
    if (this.boundHandleClick) {
      this.element.removeEventListener('click', this.boundHandleClick);
    }
  }

  handleClick(event) {
    // Get the search input value
    const searchInput = document.getElementById('search-query');
    
    if (searchInput && searchInput.value.trim()) {
      event.preventDefault();
      
      const query = searchInput.value.trim();
      debug("Handling chat button click with query:", query);
      
      // Get the current href and add the query parameter
      let href = this.element.getAttribute('href');
      
      // Check if the href already has query parameters
      const separator = href.includes('?') ? '&' : '?';
      href += `${separator}query=${encodeURIComponent(query)}`;
      
      debug("Navigating to:", href);
      
      // Use Turbo to navigate to the chat page with the query
      const turboFrame = this.element.getAttribute('data-turbo-frame');
      if (turboFrame) {
        Turbo.visit(href, { frame: turboFrame });
      } else {
        window.location.href = href;
      }
    }
    // If there's no query, the default link behavior will happen (just open the chat modal)
  }
}
